import { Container, Typography } from "@mui/material";
import { useEffect } from "react";
import { useMicrospecDynamicUIContext } from "../../../MicrospecDynamicUI/GlobalProvider";
import { MediaRestrictionsProvider } from "../../hooks/useMediaRestriction/useMediaRestriction";
import loadPdf from "../../utils/PdfViewer/loadPdf";
import "./style.css";
import testPdf from "./test.pdf";

const TradingGuide = () => {
  const { cloudProvider } = useMicrospecDynamicUIContext();

  useEffect(() => {
    loadPdf(testPdf, "pdfViewer", {}, "SIZED_CONTAINER");
  }, []);
  return (
    <Container maxWidth="xl" sx={{ minHeight: "100vh" }}>
      <Typography variant="h4" component="h2" gutterBottom>
        Trading Guide
      </Typography>
      <MediaRestrictionsProvider
        idToDisplay={`${cloudProvider.auth?.currentUser?.uid.substring(
          0,
          5
        )}-${cloudProvider.auth?.currentUser?.uid.substring(
          cloudProvider.auth?.currentUser?.uid.length - 5,
          cloudProvider.auth?.currentUser?.uid.length
        )}`}
      >
        <div
          id="pdfViewer"
          className="pdfViewer"
          style={{
            height: "100%",
            width: "100%",
            minHeight: "100vh !important",
          }}
        />
      </MediaRestrictionsProvider>
    </Container>
  );
};

export default TradingGuide;
